import {jwtDecode} from 'jwt-decode';

export interface JwtPayload {
  sub: string;
  email: string;
  fullName: string | null;
  teamId: string | null;
  staffId: string | null;
}

export interface JwtParsedUser {
  id: string;
  email: string;
  fullName: string | null;
  teamId: string | null;
  staffId: string | null;
}

export const parseJwtUser = (token: string | null): JwtParsedUser | null => {
  try {
    if (!token) return null;
    const {sub, email, fullName, teamId, staffId} = jwtDecode(token) as JwtPayload;
    return {id: sub, email, fullName, teamId, staffId};
  } catch (_err) {
    return null;
  }
};
